import { render, staticRenderFns } from "./ReviewNew.vue?vue&type=template&id=3c27014d&"
import script from "./ReviewNew.vue?vue&type=script&lang=js&"
export * from "./ReviewNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports